/**
 * Vue entry point for Griffschrift Converter
 *
 * Alle HTTP-Aufrufe laufen über den handgeschriebenen `apiClient` (`@/api-client`) mit
 * RELATIVEN Pfaden (same-origin): in Produktion der eigene Origin, im Dev-Server greift der
 * Vite-Proxy (/api, /ws → localhost:9000). Der generierte hey-api-Client liefert nur noch die
 * Typen – es gibt keine `client.setConfig`-Bootstrap-Pflicht mehr.
 *
 * `VueQueryPlugin` (@tanstack/vue-query) ist die RUNTIME-Bibliothek als Response-Cache für
 * `POST /api/note-grips` (`useNoteGrips`) – NICHT das entfernte hey-api-Generator-Plugin
 * (die generierten Query-Hooks bleiben tot). Der QueryClient bleibt hier unkonfiguriert;
 * alle note-grips-spezifischen Defaults stehen per-Query in `useNoteGrips`.
 */

import {createApp} from 'vue';
import {createPinia} from 'pinia';
import {QueryClient, VueQueryPlugin} from '@tanstack/vue-query';
import '@/styles/global.css';
// Add Tailwind import so styles are bundled and processed by Vite/Tailwind
import App from '@/App.vue';
import {createAppRouter} from '@/router/createAppRouter';
import {bindMainTabRouter} from '@/router/mainTabNavigation';
import {routes} from '@/router/routes';

import {Icon} from '@iconify/vue'
import type {ComponentPublicInstance} from "@vue/runtime-core";

const app = createApp(App);
app.component('Icon', Icon)
app.use(createPinia());
const router = createAppRouter(routes);
bindMainTabRouter(router);
app.use(router);
app.use(VueQueryPlugin, {queryClient: new QueryClient()});
const warnHandler = (msg: string, instance: ComponentPublicInstance<unknown> | null, trace: string) => {
    // `trace` is the component hierarchy trace
    console.warn('Vue Warning', msg, trace, instance, {element: instance?.$el, parent: instance?.$parent})


};
app.config.warnHandler = warnHandler
const errorHandler = (err: unknown, instance: ComponentPublicInstance<unknown> | null, info: string) => {
    // `trace` is the component hierarchy trace
    console.error('Vue Error', err, info, instance)
};
app.config.errorHandler = errorHandler
app.mount('#app');
